<template>
  <div>
    <span class="text-danger small"><slot></slot></span>
  </div>
</template>

<script>
export default {
  name: 'Form-error',
};
</script>